import { Spinner } from "@chai/ui";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

import { useAuth } from "../auth";

export const Route = createFileRoute("/")({
  component: IndexRoute,
});

function IndexRoute() {
  const auth = useAuth();
  const navigate = useNavigate();
  // Effect-based redirect — same hazard class as _app.tsx's guard: a
  // render-time <Navigate> re-schedules on every re-render while the auth
  // query settles, which can amplify into an OOM update loop.
  const dest = auth.isLoading
    ? null
    : !auth.me
      ? "/signin"
      : auth.me.user.artifact_only
        ? "/shared"
        : auth.me.memberships.length === 0
          ? "/onboarding"
          : "/workspaces";
  useEffect(() => {
    if (dest) void navigate({ to: dest, replace: true });
  }, [dest, navigate]);
  return (
    <div className="flex h-dvh items-center justify-center">
      <Spinner size={20} className="text-[var(--color-primary)]" />
    </div>
  );
}
